var _a, _b;
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import triggerAnalyticsEvent, { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent';
export var Analytics;
(function (Analytics) {
    Analytics["Activity"] = "activity";
    Analytics["AdditionalInfo"] = "additional info";
    Analytics["AdditionalTransactions"] = "additional transactions";
    Analytics["AdditionalTransactionsError"] = "additional transactions:error";
    Analytics["MoreTransactions"] = "more transactions";
    Analytics["LessTransactions"] = "less transactions";
    Analytics["MoreInfo"] = "more info";
    Analytics["Billing"] = "billing";
    Analytics["Body"] = "body";
    Analytics["Cancel"] = "cancel";
    Analytics["CancelConfirmation"] = "cancel confirmation";
    Analytics["CancelInProgress"] = "cancel-in-progress";
    Analytics["CancelThisDispute"] = "cancel this dispute";
    Analytics["Close"] = "close";
    Analytics["CommentsOnly"] = "comments only";
    Analytics["Complete"] = "complete";
    Analytics["CompleteFailure"] = "complete:failure";
    Analytics["ConfirmCancelError"] = "cancel-confirmation:error";
    Analytics["ConfirmExit"] = "exit-confirmation";
    Analytics["CreditAlreadyIssued"] = "credit already issued";
    Analytics["Credits"] = "credits";
    Analytics["DeleteConfirmation"] = "delete confirmation";
    Analytics["Dispute"] = "dispute";
    Analytics["DisputeTransaction"] = "dispute-transaction";
    Analytics["Documents"] = "documents";
    Analytics["Error"] = "error";
    Analytics["ErrorFileSize"] = "error-filesize";
    Analytics["ErrorFileType"] = "error-filetype";
    Analytics["Fail"] = "failure";
    Analytics["FAQs"] = "faqs";
    Analytics["FileDelete"] = "file-delete";
    Analytics["Footer"] = "footer";
    Analytics["Form"] = "form";
    Analytics["FraudTeam"] = "fraud-solution-team";
    Analytics["GetDisputes"] = "get-disputes-api-error";
    Analytics["LimitError"] = "limit error";
    Analytics["MaxAttachments"] = "max attachments";
    Analytics["MultipleDocuments"] = "multiple documents";
    Analytics["MultipleDocumentsAndComments"] = "multiple documents and comments";
    Analytics["GoBack"] = "go-back";
    Analytics["NotEligible"] = "not eligible";
    Analytics["NoTransactions"] = "no transactions";
    Analytics["NotRecognized"] = "form:no-recognize-charge";
    Analytics["OnlineChat"] = "online chat";
    Analytics["Popup"] = "popup";
    Analytics["Preview"] = "preview";
    Analytics["Questionnaire"] = "questionnaire";
    Analytics["QuestionnaireError"] = "questionnaire:error";
    Analytics["RecognizeCharge"] = "form:recognize-charge";
    Analytics["RecurringCharge"] = "recurring charge";
    Analytics["RecurringTransactions"] = "recurring transactions";
    Analytics["Redispute"] = "redispute";
    Analytics["RedisputeTransaction"] = "redispute this transaction";
    Analytics["Review"] = "review";
    Analytics["SecurityFailure"] = "security failure";
    Analytics["SecurityScan"] = "security scan";
    Analytics["ServerError"] = "server-error";
    Analytics["SingleDocument"] = "single document";
    Analytics["SingleDocumentAndComments"] = "single document and comments";
    Analytics["SingleRecurringTransaction"] = "single recurring transaction";
    Analytics["MultipleRecurringTransactions"] = "multiple recurring transactions";
    Analytics["Sorry"] = "we-are-sorry";
    Analytics["Start"] = "start";
    Analytics["Status"] = "status";
    Analytics["Submit"] = "submit";
    Analytics["Transaction"] = "transaction";
    Analytics["TransactionEnrichment"] = "transaction-enrichment";
    Analytics["TransactionError"] = "transaction:error";
    Analytics["UploadDocuments"] = "upload-documents";
    Analytics["Upload_Documents"] = "upload_documents";
    Analytics["UploadFailure"] = "upload failure";
    Analytics["View"] = "view";
    Analytics["YesClose"] = "yes-close";
    Analytics["YesDelete"] = "yes-delete";
})(Analytics || (Analytics = {}));
var _c = ((_a = window._SFDDL) === null || _a === void 0 ? void 0 : _a.pageInfo) || {}, CountryLanguage = _c.Country_Language, SiteIdentifier = _c.SiteIdentifier, Device = _c.Device, PNL = _c.PNL, ClientName = _c.ClientName, CustomerType = _c.CustomerType, Product = _c.Product, PageKind = _c.PageKind, pageName = _c.pageName, PageFunction = _c.PageFunction, PageSubFunction = _c.PageSubFunction, Token = _c.Token, Message = _c.Message, MessageType = _c.MessageType, ErrorMessage = _c.ErrorMessage;
if ((_b = window._SFDDL) === null || _b === void 0 ? void 0 : _b.pageInfo) {
    analyticsConfig.defaults.Country_Language = CountryLanguage;
    analyticsConfig.defaults.SiteIdentifier = SiteIdentifier;
    analyticsConfig.defaults.Device = Device;
    analyticsConfig.defaults.PNL = PNL;
    analyticsConfig.defaults.ClientName = ClientName;
    analyticsConfig.defaults.CustomerType = CustomerType;
    analyticsConfig.defaults.Product = Product;
    analyticsConfig.defaults.PagePageKind = PageKind;
    analyticsConfig.defaults.pageName = pageName;
    analyticsConfig.defaults.PageFunction = PageFunction;
    analyticsConfig.defaults.PageSubFunction = PageSubFunction;
    analyticsConfig.defaults.Token = Token;
    analyticsConfig.defaults.Message = Message;
    analyticsConfig.defaults.MessageType = MessageType;
    analyticsConfig.defaults.ErrorMessage = ErrorMessage;
    analyticsConfig.defaults.SiteIdentifier = SiteIdentifier;
}
export default triggerAnalyticsEvent;
//# sourceMappingURL=analyticsMiddleware.js.map